import React, { useEffect, useState } from 'react'
import {  MwSpinnerButton, NoDataFound } from '../../components/ui'
import RatingListItem from './RatingListItem'
import { useTranslation } from 'react-i18next'

const RatingList = ({data,loading,onDeleteSuccess}) => {
    const [t] = useTranslation('global')
    const [currentPage, setCurrentPage] = useState(1)
    const itemsPerPage = 15
    const allItems = Array.isArray(data?.data) ? data.data : []
    const totalPages = Math.max(1, Math.ceil(allItems.length / itemsPerPage))
    const safeCurrentPage = Math.min(currentPage, totalPages)
    const startIndex = (safeCurrentPage - 1) * itemsPerPage

    const paginatedItems = allItems.slice(startIndex, startIndex + itemsPerPage)

    useEffect(() => {
        setCurrentPage(1)
    }, [data])

    return (
        <div>
            {
                loading ? 
                    <MwSpinnerButton  isFullCenter={true} withLabel={false} />
                : allItems.length > 0 ?
                    <div className='text-xs'>
                        <div className='grid grid-cols-[40px_1.5fr_1.5fr_1.8fr_1fr_1fr_1fr_1fr_1fr_1fr_1fr_0.9fr] gap-2 items-center bg-slate-200 p-3 rounded-t-xl font-bold text-[11px] text-slate-700'>
                            <div className='text-center'>#</div>
                            <div className='text-center'>{t('rating.serviceRating')}</div>
                            <div className='text-center'>{t('rating.employeeRating')}</div>
                            <div className='text-center'>{t('rating.ratingDate')} / {t('rating.ratingTime')}</div>
                            <div className='text-center'>{t('rating.ipAddress')}</div>
                            <div className='text-center'>{t('rating.city')}</div>
                            <div className='text-center'>{t('rating.country')}</div>
                            <div className='text-center'>{t('rating.status')}</div>
                            <div className='text-center'>{t('rating.type')}</div>
                            <div className='text-center'>{t('rating.details')}</div>
                            <div className='text-center'>{t('rating.complaintsHistory')}</div>
                            <div className='text-center'>{t('common.delete')}</div>
                        </div>
                        {
                            paginatedItems.map((item,index) => <RatingListItem key={item._id} index={startIndex + index} item={item} onDeleteSuccess={onDeleteSuccess} /> )
                        }
                        {totalPages > 1 && (
                            <ul className='list-none flex gap-3 border-t pt-3 px-5 cursor-default'>
                                <li
                                    className={`hover:font-bold ${safeCurrentPage <= 1 ? 'opacity-40 pointer-events-none' : 'cursor-pointer'}`}
                                    onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                                >
                                    {t('common.previous')}
                                </li>
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
                                    <li
                                        key={pageNumber}
                                        className={`hover:font-bold ${pageNumber === safeCurrentPage ? 'font-bold text-indigo-600' : 'cursor-pointer'}`}
                                        onClick={() => setCurrentPage(pageNumber)}
                                    >
                                        {pageNumber}
                                    </li>
                                ))}
                                <li
                                    className={`hover:font-bold ${safeCurrentPage >= totalPages ? 'opacity-40 pointer-events-none' : 'cursor-pointer'}`}
                                    onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
                                >
                                    {t('common.next')}
                                </li>
                            </ul>
                        )}
                    </div>:
                    <NoDataFound msg={t('rating.noRatings')} />
            }
        </div>
    )
}

export default RatingList
